@if (isShowArquivosAnexados) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <div class="d-flex justify-content-end">
      </div>
      <div class="row mt-3">
        <div class="col-lg-12">
          <h1 class="titulo">Arquivo(s) anexado(s)</h1>
          <button id="botaoFecharModal" class="botaoFecharModal" (click)="abrirFechar()">
            <svg width="24" height="24" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M25.9507 7.06407C25.2348 6.34811 24.074 6.34811 23.358 7.06407L16.6542 13.7679L9.9505 7.06417C9.23454 6.34821 8.07373 6.34821 7.35777 7.06417C6.64181 7.78013 6.64181 8.94093 7.35777 9.65689L14.0615 16.3606L7.35797 23.0641C6.64201 23.7801 6.64201 24.9409 7.35797 25.6568C8.07393 26.3728 9.23474 26.3728 9.9507 25.6568L16.6542 18.9533L23.3578 25.6569C24.0738 26.3729 25.2346 26.3729 25.9505 25.6569C26.6665 24.941 26.6665 23.7802 25.9505 23.0642L19.2469 16.3606L25.9507 9.6568C26.6667 8.94083 26.6667 7.78003 25.9507 7.06407Z" fill="#878787"/>
            </svg>
          </button>
          <div class="subtitulo">
            Aqui você encontra todos os arquivos que foram anexados à esta
            ocorrência
          </div>
        </div>
        <div class="painel-arquivos">
          @if (arquivosAnexados.length > 0) {
            <div class="subtitulo-arquivos-encontrados">
              Encontramos {{ arquivosAnexados.length }} arquivo(s) enviado(s)
            </div>
          } @else {
            <div class="subtitulo-arquivos-encontrados">
              Nenhum arquivo exportado
            </div>
          }
          <div class="lista-arquivos-anexados-ul">
            <mat-grid-list cols="4" rowHeight="34px">
              @for (arquivo of arquivosAnexados; track arquivo) {
                <mat-grid-tile>
                  {{ arquivo }}
                </mat-grid-tile>
              }
            </mat-grid-list>
          </div>
        </div>
      </div>
    </div>
  </div>
}
